<template>
  <div>
    <vs-popup :title="$t('Edit')" :active.sync="showModal">
      <form v-if="showModal">
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.minOrderQuantity"
          name="minQuantity"
          :label="$t('MinOrderQuantity')"
          v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
        />
        <span class="text-danger text-sm" v-show="errors.has('minQuantity')">{{
          errors.first("minQuantity")
        }}</span>

        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.maxOrderQuantity"
          name="maxQuantity"
          :label="$t('MaxOrderQuantity')"
          v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
        />
        <span class="text-danger text-sm" v-show="errors.has('maxQuantity')">{{
          errors.first("maxQuantity")
        }}</span>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.limitationOnPurchase"
          name="limitationOnPurchase"
          :label="$t('limitationOnPurchase')"
          v-validate="{ regex: '^([0-9]+)$' }"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('limitationOnPurchase')"
          >{{ errors.first("limitationOnPurchase") }}</span
        >

        <label class="vs-select--label">{{ $t("ProductStatus") }}</label>
        <div>
          <v-select
            label="name"
            name="pStatus"
            :options="productStates"
            :value="productStates.filter((x) => x.id == model.status)[0].name"
            @input="statusChanged"
            :clearable="false"
            v-validate="{ required: true }"
            :reduce="(x) => x.id"
            dir="rtl"
            class="mb-6"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('pStatus')">{{
            errors.first("pStatus")
          }}</span>
        </div>
        <vs-button
          type="filled"
          class="float-right mb-10"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .text-danger {
  position: relative;
  top: -10px;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    minQuantity: {
      required: "لطفا حداقل تعداد سفارش را وارد نمایید.",
      regex: "مقدار وارد شده مجاز نمی باشد",
    },
    maxQuantity: {
      required: "لطفا حداکثر تعداد سفارش را وارد نمایید.",
      regex: "مقدار وارد شده مجاز نمی باشد",
    },
    limitationOnPurchase: {
      regex: "مقدار وارد شده مجاز نمی باشد",
    },
    pState: {
      required: "لطفا وضعیت محصول را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_Contract_Management_ProductPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      productStates: [
        { name: "آماده فروش", id: 0 },
        { name: "به زودی", id: 1 },
        { name: "توقف فروش", id: 2 },
        { name: "توقف تولید", id: 3 },
      ],
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      updateContractProductsInfo: "sale/updateContractProductsInfo",
    }),
    statusChanged(status) {
      this.model.status = status;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateContractProductsInfo(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              setTimeout(() => {
                this.$emit("finish");
              }, 0);
              this.model = {};
              this.$validator.reset();
            });
          });
        }
      });
    },
  },
  watch: {
    show() {
      this.$validator.reset();
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
